import { render, staticRenderFns } from "./config_sql.vue?vue&type=template&id=2950c995"
import script from "./config_sql.vue?vue&type=script&lang=js"
export * from "./config_sql.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports